module.exports = __webpack_public_path__ + "img/Frame4334.04b58730.png";